import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    showTimeline: true,
    showGlossary: false,
    showProfile: false,
    showYearDetail: false,
    showMap: false,
    showPrimarySource: false,
    currPerson: "",
    currYear: "",
    currSource: "",
    currSourceLink: "",
    currSourceId: "",
    mapYear: "",
    mapEventId: ""
  },

  mutations: {
  },

  actions: {
  }
})
export default store;